import api from 'config/api'

export const signIn = async (params: {
  verification_token: string
  code_2fa: string
  referral_code?: string
}): Promise<string> => {
  try {
    const { data } = await api.post('/v2/auth', {
      params: params,
    })

    return data.response?.token
  } catch (ignore) {
    return null
  }
}

export const signInRateLimited = async (params: {
  verification_token: string
  code_2fa: string
  referral_code?: string
}): Promise<{
  result: boolean
  response: string
  message: string
}> => {
  const { data } = await api.post('/v2/auth/rate-limited', {
    params: params,
  })

  return { result: data.result, response: data.response?.token, message: data.message }
}

export const signInAdmin = async (params: { login: string; password: string }): Promise<string> => {
  try {
    const { data } = await api.post('/v2/auth/admin', {
      params: params,
    })

    return data.response?.token
  } catch (ignore) {
    return null
  }
}

export const signUpAdmin = async (params: {
  login: string
  password: string
  email: string
  verification_token: string
}): Promise<string> => {
  try {
    const { data } = await api.post('/v2/auth/register-admin', {
      params: params,
    })

    return data.response?.token
  } catch (ignore) {
    return null
  }
}

export const active2fa = async (params: {
  verification_token: string
  code_2fa: string
  secret_2fa: string
}): Promise<boolean> => {
  try {
    const { data } = await api.post('/v2/auth/2fa/activate', {
      params: params,
    })

    return !!data.result
  } catch (ignore) {
    return false
  }
}

export const remove2fa = async (params: { code_2fa: string; verification_token: string }): Promise<boolean> => {
  try {
    const { data } = await api.post('/v2/auth/2fa/remove', {
      params: params,
    })

    return data.result
  } catch (ignore) {
    return false
  }
}

export const fallbackRemove2fa = async (params: { verification_token: string[] }): Promise<boolean> => {
  try {
    const { data } = await api.post('/v2/auth/2fa/remove/fallback', {
      params: params,
    })

    return data.result
  } catch (ignore) {
    return false
  }
}

export const create2fa = async (): Promise<any> => {
  try {
    const { data } = await api.post('/v2/auth/2fa/create')
    return data
  } catch (ignore) {
    return false
  }
}
